import React from "react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
const relatedServices = [{
  title: "ליווי סיעודי בבית החולים",
  description: "השגחה צמודה וליווי מקצועי של מטפל מוסמך במהלך אשפוז, כדי להבטיח שהיקיר לכם לעולם לא יישאר לבד.",
  link: "/CaregiverServicePagesPage"
}, {
  title: "סיוע בהגשת תביעות סיעוד",
  description: "ייעוץ והכוונה מקצועית למיצוי זכויות מול חברות הביטוח והמוסד לביטוח לאומי לקבלת המענה המקסימלי.",
  link: "/ProfessionalBlogPage"
}];
export default function RelatedServicesGrid() {
  return <section data-section-id="260705" id="שירותים-סיעודיים" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-primary mb-4">
            שירותים משלימים
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            גלו את מגוון הפתרונות המקצועיים שלנו המותאמים אישית לצרכי המשפחה והמטופל.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:gap-6">
          {relatedServices.map((service, i) => <Link key={i} to={service.link} className="block group outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-lg" data-index={i}>
              <Card className="flex flex-col md:flex-row items-start md:items-center p-6 md:p-8 gap-4 md:gap-0 transition-all duration-300 group-hover:shadow-lg group-hover:border-primary/20 bg-card rounded-lg border-border">
                <div className="md:w-[35%] shrink-0">
                  <h3 className="font-default font-semibold text-xl text-foreground group-hover:text-secondary transition-colors">
                    {service.title}
                  </h3>
                </div>
                
                <div className="hidden md:block w-px self-stretch bg-border mx-8 min-h-[3rem]"></div>
                
                <div className="flex-1">
                  <p className="text-muted-foreground text-base md:text-lg leading-relaxed font-default">
                    {service.description}
                  </p>
                </div>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}